export default __webpack_public_path__ + "static/IN-8015HD-vs-IN-6014HD_2-b42b823cef650c411d532a1dcbb4f003.webp";